import * as React from 'react';
import {
  Button,
  CircularProgress,
  FormControlLabel,
  InputAdornment,
  Switch,
  TextField,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { useAppTranslation } from '../../services/i18n';
import { isFilterActive, WorkplacesFilter } from '../../store/workplaces';

interface Props {
  filter: WorkplacesFilter;
  isFiltering: boolean;
  onChange: (filter: WorkplacesFilter) => void;
  onReset: () => void;
}

export const WorkplaceFilters: React.FC<Props> = ({ filter, isFiltering, onChange, onReset }) => {
  const t = useAppTranslation();

  return (
    <div className={'workplace-filters'}>
      <TextField
        variant={'standard'}
        label={t('workplaces.filters.searchLabel')}
        placeholder={t('workplaces.filters.searchPlaceholder')}
        value={filter.search}
        onChange={(event) => onChange({ ...filter, search: event.target.value })}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position={'start'}>
                <Search fontSize={'small'} />
              </InputAdornment>
            ),
            endAdornment: isFiltering ? <CircularProgress size={16} /> : undefined,
          },
        }}
        className={'workplace-filters__search'}
      />

      <span className={'workplace-filters__spacer'} />

      {/* the switches and the reset belong together, so a narrow page wraps them as one
          block instead of pushing the reset off the row */}
      <div className={'workplace-filters__switches'}>
        <FormControlLabel
          control={
            <Switch
              checked={filter.withoutLeader}
              onChange={(event) => onChange({ ...filter, withoutLeader: event.target.checked })}
            />
          }
          label={t('workplaces.filters.withoutLeader')}
        />
        <FormControlLabel
          control={
            <Switch
              checked={filter.withoutMembers}
              onChange={(event) => onChange({ ...filter, withoutMembers: event.target.checked })}
            />
          }
          label={t('workplaces.filters.withoutMembers')}
        />
        <Button size={'small'} disabled={!isFilterActive(filter)} onClick={onReset}>
          {t('workplaces.filters.reset')}
        </Button>
      </div>
    </div>
  );
};
